import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Input } from 'rsuite'

let searchBox
const SearchBox = (props) => {
  const { onPlacesChanged, locationName } = props
  const inputRef = useRef(null)
  const [placeName, setPlaceName] = useState()

  const handlePlacesChanged = () => {
    if (onPlacesChanged) {
      onPlacesChanged(searchBox?.getPlaces())
    }
  }

  useEffect(() => {
    console.log('run searchBox')
    // eslint-disable-next-line react/no-find-dom-node
    const input = ReactDOM.findDOMNode(inputRef.current)
    searchBox = new google.maps.places.SearchBox(input)
    searchBox.addListener('places_changed', handlePlacesChanged)
    return () => {
      google.maps.event.clearInstanceListeners(searchBox)
    }
  }, [])

  useEffect(() => {
    console.log('locationName',locationName)
    locationName && setPlaceName(locationName)
  }, [locationName])

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Input ref={inputRef} {...props} type="text" defaultValue={placeName} />
}

SearchBox.propTypes = {
  placeholder: PropTypes.string,
  onPlacesChanged: PropTypes.func,
}

export default SearchBox
